export enum ModuleCachingStatus {
  NotCached = "NOT_CACHED",
  Caching = "CACHING",
  Cached = "CACHED",
}

export enum CacheOperationError {
  Failed = "FAILED",
  Aborted = "ABORTED",
}

type ModuleCachingState =
  | {
      status: ModuleCachingStatus.NotCached;
      /** Error occurred during a previous caching attempt. */
      error?: CacheOperationError;
    }
  | {
      status: ModuleCachingStatus.Caching;
      assetsCount: null | number;
      cachedAssetsCount: number;
    }
  | { status: ModuleCachingStatus.Cached };
export default ModuleCachingState;
